import React from "react";
import { Breadcrumbs, Typography, Box } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * Zdieľaný breadcrumb pre faktúračné stránky: DSOK / Fakturácia / [História | Zoznam faktúr].
 * Aktívna položka je zvýraznená (nie odkaz), druhá je klikací odkaz → prepínanie.
 * @param {{ active: "history" | "invoices" }} props
 */
const BillingBreadcrumbs = ({ active }) => {
  const { t } = useTranslation();

  const leaf = (key, i18nKey, def, to) =>
    active === key ? (
      <Typography component="span" color="text.primary" sx={{ fontWeight: 600 }}>
        {t(i18nKey, { defaultValue: def })}
      </Typography>
    ) : (
      <Link to={to}>{t(i18nKey, { defaultValue: def })}</Link>
    );

  return (
    <Breadcrumbs
      sx={{
        mb: 3,
        "& a": { color: "text.secondary", textDecoration: "none" },
        "& a:hover": { textDecoration: "underline" },
      }}
    >
      <Link to="/customer/dsok">
        {t("sidebar.menuItem.dsokSettings", { defaultValue: "DSOK" })}
      </Link>
      <Typography color="text.secondary">
        {t("sidebar.menuItem.billing", { defaultValue: "Fakturácia" })}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {leaf(
          "history",
          "sidebar.menuItem.billingHistory",
          "História",
          "/dsok/billing/history",
        )}
        <Typography component="span" color="text.disabled">
          |
        </Typography>
        {leaf(
          "invoices",
          "sidebar.menuItem.billingInvoices",
          "Zoznam faktúr",
          "/dsok/billing/invoices",
        )}
      </Box>
    </Breadcrumbs>
  );
};

export default BillingBreadcrumbs;
